import { Injectable } from '@angular/core';
import { OAuthService } from 'angular-oauth2-oidc';

@Injectable()
export class AuthorizationService {

    constructor(private oauthService: OAuthService) { }


    public Logout() {
        this.oauthService.logOut();
    }

    get FullName() {
        var claims = this.oauthService.getIdentityClaims();
        if (!claims) return null;
        return claims['http://schemas.xmlsoap.org/ws/2005/05/identity/claims/name'];
    }
    get userRole() {
        var claims = this.oauthService.getIdentityClaims();
        if (!claims) return null;
        return claims['role'];
    }

    get userId() {
        var claims = this.oauthService.getIdentityClaims();
        if (!claims) return null;
        return claims['userId'];
    }

    get email() {
        var claims = this.oauthService.getIdentityClaims();
        if (!claims) return null;
        return claims['email'];
    }

    get authToken() {
        return this.oauthService.getAccessToken();
    }

    get isLoggedIn() {
        return this.oauthService.hasValidAccessToken();
    }
}
